// extracted by mini-css-extract-plugin
export default {"wrapper":"_FhXVn","wrapper--content-167":"KSOL9e","wrapper--content-237":"IQOBB6","row--space-40":"juhLgI","row--space-64":"BOBlgu","caption":"RC77UW","banner--horizontal":"PiCz37"};